import { RouteRecordRaw } from 'vue-router';
import { route } from '@/router/utils'
// import { allPermissions } from '@access/index'
// import { accessPermission } from '@/permissions/permissions'

// const {
//   STAFF: {
//     USER: {
//       VIEW
//     },
//   },
// } = allPermissions

const list = () => import('./List.vue')
const details = () => import('./details/Details.vue')

export const BUYERS_LIST_PAGE_NAME = 'cabinet:buyers'
export const BUYER_DETAILS_PAGE_NAME = 'cabinet:buyer'

// URLs
export const BUYERS_LIST_PAGE_URL = ''
export const BUYER_DETAILS_PAGE_URL = 'details/:id?/'

export function createRoutes(options): RouteRecordRaw[] {
  return [
    route(BUYERS_LIST_PAGE_URL, list, BUYERS_LIST_PAGE_NAME, {
      meta: {
        breadcrumb: 'buyers',
        // ...accessPermission([VIEW], options),
      }
    }),
    route(BUYER_DETAILS_PAGE_URL, details, BUYER_DETAILS_PAGE_NAME, {
      meta: {
        breadcrumb: 'buyer-details',
        parent: BUYERS_LIST_PAGE_NAME,
        // ...accessPermission([VIEW], options),
      }
    }),
  ]
}
